/* ==========================================================================
   Kollectixe — crossword SMS pop-up (2026-10-25, Jalen; idea 1 of
   clients/kollectixe/docs/popup_options_2026-10-25.html)

   Flow:  trigger (delay / desktop exit intent) -> one tap on the grid -> the
          crossword fills itself in (KOLLECTIXE across, OFF and TEN down) and
          TEN / OFF turn red -> 10% off shows (EVERY visitor gets the same one)
          -> "Claim" reveals the Postscript pop-up, which collects the phone
          number and texts the code.

   Postscript hold and lifecycle (once per visitor, cooldown after a dismiss,
   reopen tab, subscriber skip, scroll lock, instant hand-off) are a port of
   fraternal theme_variant_a assets/frt-slot-popup.js (itself the Nasty Rugs
   paint pop-up). Config: window.KX_XWORD_CFG, written by
   snippets/kx-xword-config.liquid.

   Kollectixe-only: a tap on a sold-out PDP's notify button lifts the hold, so
   Postscript's Back in Stock pop-up can show while the crossword is unclaimed.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-kx-xword]');
  if (!root || typeof root.showModal !== 'function') return;

  var c0 = window.KX_XWORD_CFG || {};
  function num(v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; }
  var cfg = {
    enabled:      c0.enabled === true,
    popupId:      String(c0.popupId || '').trim(),
    delay:        num(c0.delay, 7),
    exitIntent:   c0.exitIntent === true,
    cooldownDays: num(c0.cooldownDays, 7),
    force:        /[?&]kx_xword=1\b/.test(location.search)
  };
  var ready = cfg.enabled && !!cfg.popupId;

  var KEY = 'kx_xword_v1';
  function readState() { try { return JSON.parse(localStorage.getItem(KEY) || 'null') || {}; } catch (e) { return {}; } }
  function writeState(patch) {
    try { var s = readState(); for (var k in patch) s[k] = patch[k]; localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {}
  }
  function emit(action, extra) {
    var d = { action: action }; if (extra) for (var k in extra) d[k] = extra[k];
    try { document.dispatchEvent(new CustomEvent('kx:xword-popup', { detail: d })); } catch (e) {}
  }

  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var finePointer  = window.matchMedia && matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------------------------------------------------------------- gating */
  function fromOurTexts() { return /utm_source=postscript/i.test(location.search); }
  function suppressedLocally() {
    if (cfg.force) return false;
    if (!ready || fromOurTexts()) return true;
    var s = readState();
    if (s.claimed) return true;
    if (s.dismissed && Date.now() - s.dismissed < cfg.cooldownDays * 864e5) return true;
    return false;
  }
  // getSubscriberId may be sync or a promise depending on the SDK build.
  function isSubscriber(cb) {
    var ps = window.postscript, r;
    if (!ps || typeof ps.getSubscriberId !== 'function') return cb(false);
    try { r = ps.getSubscriberId(); } catch (e) { return cb(false); }
    if (r && typeof r.then === 'function') {
      var done = false;
      r.then(function (id) { if (!done) { done = true; cb(!!id); } }, function () { if (!done) { done = true; cb(false); } });
      setTimeout(function () { if (!done) { done = true; cb(false); } }, 1500);
    } else cb(!!r);
  }

  /* ------------------------------------------------------- Postscript hold
     html.kx-ps-hold (set in <head> by snippets/kx-xword-hold.liquid) keeps Postscript's frame invisible and
     click-through while unclaimed. Once the crossword is solved we open OUR configured pop-up ourselves, still
     hidden, so it is fully drawn before Claim; Claim reveals it. */
  var holding = document.documentElement.classList.contains('kx-ps-hold');
  function holdPostscript() { if (!holding) { holding = true; document.documentElement.classList.add('kx-ps-hold'); } }
  function releaseHold() { holding = false; document.documentElement.classList.remove('kx-ps-hold'); }
  var preopened = false;
  function psOpen() {
    var ps = window.postscript;
    if (!cfg.popupId || !ps || !ps.popups || typeof ps.popups.open !== 'function') return false;
    try { ps.popups.open(cfg.popupId, { activePopupBehavior: 'ALWAYS_DISMISS', respectPopupStatus: true }); return true; } catch (e) { return false; }
  }
  function preopenPostscript() { if (holding && !preopened && psOpen()) preopened = true; }

  // The restock flow on sold-out PDPs opens Postscript's Back in Stock pop-up: never hold that one.
  document.addEventListener('click', function (e) {
    if (holding && e.target.closest && e.target.closest('[data-kx-notify], #ps__bis_target_container')) releaseHold();
  }, true);

  // Never stack on the cart drawer, another dialog, or a Postscript pop-up that is already showing.
  function somethingElseOpen() {
    var open = document.querySelectorAll('dialog[open]');
    for (var i = 0; i < open.length; i++) if (open[i] !== root) return true;
    var drawer = document.querySelector('.cart-drawer.is-open, .cart-drawer[aria-hidden="false"], [data-cart-drawer].is-open');
    if (drawer) return true;
    var ps = document.getElementById('ps__widget');
    if (ps && !holding) { var r = ps.getBoundingClientRect(); if (r.width > 200 && r.height > 200 && getComputedStyle(ps).visibility !== 'hidden') return true; }
    return false;
  }

  var shown = false, timer = null;
  function tryOpen() {
    if (shown) return;
    if (somethingElseOpen()) { timer = setTimeout(tryOpen, 4000); return; }
    shown = true; clearTimeout(timer); document.removeEventListener('mouseout', onExit);
    isSubscriber(function (sub) { if (sub && !cfg.force) return; open(); });
  }
  function onExit(e) {
    if (e.relatedTarget == null && e.clientY <= 0) {
      document.removeEventListener('mouseout', onExit);
      clearTimeout(timer); tryOpen();
    }
  }
  function arm() {
    if (cfg.force) { try { localStorage.removeItem(KEY); } catch (e) {} }
    var s = readState();
    if ((ready || cfg.force) && cfg.popupId && !s.claimed && !fromOurTexts()) holdPostscript();
    if (!cfg.force && s.claimed) return;
    if (tabWanted(s)) showTab(true);
    if (suppressedLocally()) return;
    setTimeout(warm, Math.max(0, cfg.delay - 3) * 1000);
    if (cfg.delay >= 0) timer = setTimeout(tryOpen, (cfg.force ? Math.min(cfg.delay, 1) : cfg.delay) * 1000);
    if (cfg.exitIntent && finePointer) document.addEventListener('mouseout', onExit);
  }

  /* --------------------------------------------------------------- elements */
  var grid    = root.querySelector('[data-xword-solve]');
  var claimEl = root.querySelector('[data-xword-claim]');
  var live    = root.querySelector('[data-xword-live]');
  var won = false, claimed = false, solving = false;
  var keyboardUser = false;
  root.addEventListener('keydown', function () { keyboardUser = true; }, true);
  root.addEventListener('pointerdown', function () { keyboardUser = false; }, true);
  function setState(s) { root.setAttribute('data-xword-state', s); }

  /* --------------------------------------------- lazy images + font (once) */
  var warmed = false;
  function warm() {
    if (warmed) return; warmed = true;
    var imgs = root.querySelectorAll('img[data-xword-src]');
    for (var i = 0; i < imgs.length; i++) { imgs[i].src = imgs[i].getAttribute('data-xword-src'); imgs[i].removeAttribute('data-xword-src'); }
    // The tee's engraved serif for the line under the grid; the site itself loads Anton / Archivo / JetBrains Mono /
    // Newsreader. Falls back to Newsreader.
    var f = document.createElement('link');
    f.rel = 'stylesheet'; f.href = 'https://fonts.googleapis.com/css2?family=Cinzel:wght@600&display=swap';
    document.head.appendChild(f);
  }
  function logoReady(cb) {
    var img = root.querySelector('.kx-xword__logo'), done = false, finish = function () { if (!done) { done = true; cb(); } };
    setTimeout(finish, 1200);
    if (!img || img.tagName !== 'IMG') return finish();
    if (img.decode) img.decode().then(finish, finish);
    else if (img.complete) finish(); else img.onload = img.onerror = finish;
  }

  /* ------------------------------------------------------ scroll lock (html) */
  var lockPad = '';
  function lockScroll() {
    var de = document.documentElement, sb = window.innerWidth - de.clientWidth;
    lockPad = de.style.paddingRight; de.classList.add('kx-xword-lock');
    if (sb > 0) de.style.paddingRight = sb + 'px';
  }
  function unlockScroll() { var de = document.documentElement; de.classList.remove('kx-xword-lock'); de.style.paddingRight = lockPad; }

  /* ------------------------------------------------------------ open/close */
  var opening = false;
  function open() {
    if (root.open || opening) return;
    opening = true; shown = true; clearTimeout(timer);
    document.removeEventListener('mouseout', onExit);
    hideTab(); warm();
    logoReady(function () { opening = false; if (!root.open) reveal(); });
  }
  function reveal() {
    var s = readState();
    if (s.won && !won) finish(true);
    setState(won ? 'won' : 'ready');
    root.showModal(); lockScroll();
    root.focus({ preventScroll: true });
    writeState({ shown: Date.now() });
    if (won) preopenPostscript();
    emit('open', { won: won });
  }
  root.addEventListener('close', function () {
    unlockScroll();
    if (!claimed) { writeState({ dismissed: Date.now() }); emit('dismiss', { won: won }); showTab(false); }
  });
  root.addEventListener('click', function (e) {
    if (e.target === root) root.close();                           // backdrop
    if (e.target.closest('[data-xword-close]')) root.close();
  });

  /* ----------------------------------------------------------------- solve
     One tap anywhere on the grid stamps the letters in: KOLLECTIXE across, then TEN and OFF down. TEN and OFF turn
     red and the tee line flips. No skill: every tap solves it. */
  var ORDER = [[0,0],[0,1],[0,2],[0,3],[0,4],[0,5],[0,6],[0,7],[0,8],[0,9],[1,6],[2,6],[1,1],[2,1]];
  function cell(r, c) { return grid.querySelector('[data-r="' + r + '"][data-c="' + c + '"]'); }
  function fillAll() { for (var i = 0; i < ORDER.length; i++) { var el = cell(ORDER[i][0], ORDER[i][1]); if (el) el.classList.add('is-on'); } grid.classList.add('is-busy', 'is-solved'); }
  grid.addEventListener('click', function () {
    if (won || solving) return;
    solving = true; grid.classList.add('is-busy');
    emit('start');
    if (reduceMotion) { fillAll(); solving = false; return finish(false); }
    ORDER.forEach(function (rc, i) {
      setTimeout(function () { var el = cell(rc[0], rc[1]); if (el) el.classList.add('is-on'); }, i * 80 + (rc[0] ? 250 : 0));
    });
    var end = ORDER.length * 80 + 250;
    setTimeout(function () { grid.classList.add('is-solved'); }, end + 200);
    setTimeout(function () { solving = false; finish(false); }, end + 1100);
  });

  function finish(instant) {
    if (won) return;
    won = true;
    if (instant) fillAll();
    grid.setAttribute('aria-disabled', 'true');
    setState('won');
    if (instant) return;
    if (!reduceMotion && navigator.vibrate) { try { navigator.vibrate([40, 30, 80]); } catch (e) {} }
    writeState({ won: Date.now() });
    if (live) live.textContent = 'Solved. Ten percent off: 10% off your first order is yours. We\'ll text you the code.';
    emit('reveal');
    preopenPostscript();
    if (keyboardUser && claimEl) claimEl.focus(); else root.focus({ preventScroll: true });
  }

  /* ----------------------------------------------------------------- claim
     Postscript's SDK can take several seconds to start (its phone pop-up loads in a second frame), and an open()
     made before it has its pop-up list is silently dropped. So Claim keeps the card up ("Opening…"), re-asks
     Postscript every 2 s, and steps aside only once Postscript's frame is actually drawn (still hidden by the
     hold, but sized). After 10 s with nothing, the card stays up and asks them to tap again. */
  var CLAIM_WAIT = 10000, RETRY_EVERY = 2000;
  function postscriptShowing() {
    var fs = document.querySelectorAll('iframe[src*="postscript.io"]'), vw = window.innerWidth, vh = window.innerHeight;
    for (var i = 0; i < fs.length; i++) {
      var r = fs[i].getBoundingClientRect();
      if (r.width > vw * 0.5 && r.height > vh * 0.5) return true;
    }
    return false;
  }
  function revealPostscript() {
    claimed = true;
    writeState({ claimed: Date.now() });
    hideTab();
    releaseHold(); root.close(); root.classList.remove('is-claiming');
  }
  claimEl.addEventListener('click', function (e) {
    e.preventDefault();
    if (root.classList.contains('is-claiming')) return;
    var note = root.querySelector('[data-xword-setup-note]'); if (note) note.hidden = true;
    root.classList.add('is-claiming');
    emit('claim', { via: preopened ? 'postscript-preopened' : 'postscript-popup' });
    var t0 = Date.now(), lastAsk = 0;
    if (!preopened && psOpen()) { preopened = true; lastAsk = t0; }
    (function check() {
      if (!root.open) return;
      if (postscriptShowing()) return revealPostscript();
      var now = Date.now();
      if (now - t0 > CLAIM_WAIT) {                                 // never close onto nothing: keep the card, ask again
        root.classList.remove('is-claiming');
        if (note) note.hidden = false;
        emit('claim-failed');
        return;
      }
      if (now - lastAsk > RETRY_EVERY && psOpen()) { preopened = true; lastAsk = now; }
      requestAnimationFrame(check);
    })();
  });

  /* ------------------------------------------------- reopen tab (bottom left) */
  var tab = document.querySelector('[data-xword-tab]');
  function tabWanted(s) {
    if (!tab || s.claimed || !s.dismissed || fromOurTexts()) return false;
    if (!ready && !cfg.force) return false;
    return !(s.tabHidden && Date.now() - s.tabHidden < cfg.cooldownDays * 864e5);
  }
  function showTab(checkSubscriber) {
    if (!tab || claimed || (!ready && !cfg.force)) return;
    tab.setAttribute('data-xword-won', (won || readState().won) ? 'true' : 'false');
    function show() { tab.hidden = false; tab._queueTuck && tab._queueTuck(); }
    if (!checkSubscriber) return show();
    isSubscriber(function (sub) { if (!sub) show(); });
  }
  function hideTab() { if (tab) tab.hidden = true; }
  if (tab) {
    tab.querySelector('[data-xword-tab-open]').addEventListener('click', function () { emit('tab-open'); if (!root.open) open(); });
    tab.querySelector('[data-xword-tab-close]').addEventListener('click', function () { writeState({ tabHidden: Date.now() }); hideTab(); emit('tab-hide'); });
    window.addEventListener('postscriptReady', function () { isSubscriber(function (sub) { if (sub) hideTab(); }); });
    // Never sit on a button: tuck off the edge while overlapping add-to-cart, the notify button, checkout or a
    // primary link button.
    var BUY = '.add-to-cart, .pdp-notify-btn, form[action*="/cart/add"] button, form[action*="/cart/add"] [type="submit"], ' +
              '.shopify-payment-button, shopify-accelerated-checkout, [name="checkout"], .btn, .button';
    var tq = false;
    function overlaps(a, b) { return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top; }
    function tuck() {
      tq = false; if (tab.hidden) return;
      // offset* ignore the tuck transform, so this is where the tab sits when it is showing.
      var l = tab.offsetLeft, t = tab.offsetTop, pad = { left: l - 10, right: l + tab.offsetWidth + 10, top: t - 10, bottom: t + tab.offsetHeight + 10 };
      var hit = false, els = document.querySelectorAll(BUY);
      for (var i = 0; i < els.length && !hit; i++) { var b = els[i].getBoundingClientRect(); if (b.width && b.height && overlaps(pad, b)) hit = true; }
      tab.classList.toggle('is-tucked', hit);
    }
    function queueTuck() { if (!tq) { tq = true; requestAnimationFrame(tuck); } }
    window.addEventListener('scroll', queueTuck, { passive: true });
    window.addEventListener('resize', queueTuck);
    tab._queueTuck = queueTuck;
  }

  // QA: ?kx_xword=1 forces it open from a fresh start (even while switched off); KX_XWORD.reset() clears the visitor memory.
  window.KX_XWORD = {
    open: function () { if (!root.open) open(); },
    reset: function () { try { localStorage.removeItem(KEY); } catch (e) {} }
  };

  arm();
})();
